import { render, staticRenderFns } from "./QuestionsSolution.vue?vue&type=template&id=78804d94&scoped=true"
import script from "./QuestionsSolution.vue?vue&type=script&lang=js"
export * from "./QuestionsSolution.vue?vue&type=script&lang=js"
import style0 from "./QuestionsSolution.vue?vue&type=style&index=0&id=78804d94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78804d94",
  null
  
)

export default component.exports